<script setup>
import WorksheetGrid from '@/components/garage/WorksheetGrid.vue'
</script>
<template>
  <worksheet-grid />
</template>
